import React from 'react';
import { Card } from '../ui/card';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, PieChart, Pie, Cell } from 'recharts';

const COLORS = ['#1e40af', '#059669', '#dc2626', '#ea580c', '#7c3aed', '#0891b2'];

const KPIFinanziaria = ({ bookings, filters }) => {
  const filterBookings = (bookingsList) => {
    return bookingsList.filter(booking => {
      const bookingDate = new Date(booking.booking_date);
      const bookingYear = bookingDate.getFullYear();
      const bookingMonth = bookingDate.getMonth() + 1;
      const bookingQuarter = Math.ceil(bookingMonth / 3);
      if (bookingYear !== filters.year) return false;
      if (filters.period === 'month' && filters.month) return bookingMonth === parseInt(filters.month);
      if (filters.period === 'quarter' && filters.quarter) return bookingQuarter === parseInt(filters.quarter);
      if (filters.propertyId && booking.property_id !== filters.propertyId) return false;
      return true;
    });
  };

  const currentBookings = filterBookings(bookings);

  const financialData = [
    { name: 'Ricavi Totali', value: currentBookings.reduce((sum, b) => sum + (b.guest_total || 0), 0) },
    { name: 'Incassato', value: currentBookings.filter(b => b.payment_status === 'collected').reduce((sum, b) => sum + (b.guest_total || 0), 0) },
    { name: 'Da Incassare', value: currentBookings.filter(b => b.payment_status === 'to_collect').reduce((sum, b) => sum + (b.guest_total || 0), 0) },
    { name: 'Proprietario', value: currentBookings.reduce((sum, b) => sum + (b.owner_amount || 0), 0) },
    { name: 'Margine', value: currentBookings.reduce((sum, b) => sum + (b.margin || 0), 0) }
  ];

  const costsData = [
    { name: 'Proprietario', value: currentBookings.reduce((sum, b) => sum + (b.owner_amount || 0), 0) },
    { name: 'Tasse', value: currentBookings.reduce((sum, b) => sum + (b.tourist_tax || 0), 0) },
    { name: 'Pulizie', value: currentBookings.reduce((sum, b) => sum + (b.cleaning_cost || 0), 0) },
    { name: 'Carta', value: currentBookings.reduce((sum, b) => sum + (b.card_cost || 0), 0) },
    { name: 'Piattaforma', value: currentBookings.reduce((sum, b) => sum + (b.platform_commission || 0), 0) },
    { name: 'Partner', value: currentBookings.reduce((sum, b) => sum + (b.partner_commission || 0), 0) }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">💰 Analisi Finanziaria</h2>
        <p className="text-gray-600">Dettaglio completo dei flussi finanziari</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">💼 Breakdown Finanziario</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={financialData} layout="vertical">
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis dataKey="name" type="category" width={100} />
              <Tooltip formatter={(value) => `€${value.toLocaleString('it-IT', {minimumFractionDigits: 2})}`} />
              <Bar dataKey="value" name="Importo (€)">
                {financialData.map((entry, index) => (<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Card>

        <Card className="p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">💸 Distribuzione Costi</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={costsData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {costsData.map((entry, index) => (<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />))}
              </Pie>
              <Tooltip formatter={(value) => `€${value.toFixed(2)}`} />
            </PieChart>
          </ResponsiveContainer>
        </Card>
      </div>

      <Card className="p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">📊 Dettaglio Costi</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={costsData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 11 }} />
            <YAxis />
            <Tooltip formatter={(value) => `€${value.toFixed(2)}`} />
            <Bar dataKey="value" fill="#dc2626" name="Costo (€)" />
          </BarChart>
        </ResponsiveContainer>
      </Card>
    </div>
  );
};

export default KPIFinanziaria;